module.exports = __webpack_public_path__ + "img/jiagou.8ccc0251.png";